var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PicTagCollect collect _pointer",class:[_vm.picItemInfo.isCollect === true ? 'on':'no'],on:{"click":function($event){return _vm.toggleCollect(_vm.picItemInfo)}}},[_c('i',{staticClass:"iconfont icon-collect"})])
}
var staticRenderFns = []

export { render, staticRenderFns }